export const biospecimenCategories = [
  {
    title: "Biofluids",
    image: "/images/img_rectangle_27.png",
    subtext: "",
    description:
      "Whole Blood, Plasma (Single & Double Spun), Serum, Urine, Buffy Coat, Synovial Fluid, Pleural/Ascetic Fluids, Bronchoalveolar lavage (BAL) fluid.",
  },
  {
    title: "Tissue Samples",
    image: "/images/img_rectangle_28.png",
    subtext: "",
    description: "FFPE Blocks/Slides, Frozen Tissue",
  },
  {
    title: "Cells & Blood Components",
    image: "/images/img_rectangle_29.png",
    subtext: "",
    description:
      "Peripheral Blood Mononuclear Cells (PBMCs), Platelets, Synovial Mononuclear Cells (SMNCs)",
  },
  {
    title: "Customized Collection",
    image: "/images/img_rectangle_30.png",
    subtext: "",
    description:
      "Tailored protocols developed in line with defined study objectives",
  },
];

export const procurementSteps = [
  { title: "Step 01", active: true },
  { title: "Step 02", active: false },
  { title: "Step 03", active: false },
  { title: "Step 04", active: false },
  { title: "Step 05", active: false },
];

export const labServices = [
  {
    title: "DNA/RNA Extraction from Diverse Biospecimens",
    description:
      "We provide high-quality nucleic acid extraction from a wide range of human biospecimens, using automated platforms and validated protocols to ensure purity, integrity, and consistency—ready for PCR, NGS, and genotyping applications in both diagnostics and research.",
    image: "/images/img_1.png",
    expanded: true,
  },
  {
    title: "Molecular Services: PCR, qPCR, Sequencing,",
    subtitle: "Genomic Analysis & NGS Platforms",
    description:
      "We provide expert molecular solutions featuring high-sensitivity PCR, real-time qPCR, and advanced Sequencing services. Our lab delivers precise genetic insights and data analysis for diverse research and diagnostic needs, ensuring the highest standards of accuracy, speed, and technical excellence.",
    image: "/images/img_2.png",
    expanded: true,
  },
  {
    title: "Immunohistochemistry (IHC) & FISH,",
    image: "/images/img_3.png",
    description:
      "Our lab offers expert IHC and FISH services to visualize protein expression and genetic markers in tissue samples. Using advanced staining and fluorescence techniques, we deliver precise insights into cellular health and disease, supporting oncology research and clinical pathology with high-fidelity imaging and data.",
    expanded: true,
  },
  {
    title: "Histopathology & Tissue Processing",
    image: "/images/img_4.png",
    description:
      "Our lab provides expert Tissue Processing and Histopathology services, ensuring the highest standards of sample preservation and slide preparation. From routine processing to specialized staining, we deliver clear, high-quality tissue sections that are essential for precise microscopic analysis and clinical diagnostics.",
    expanded: true,
  },
];

export const whyChooseAnviya = [
  {
    title: "Ethical Sourcing",
    description:
      "IRB-approved protocols, informed consent, full regulatory compliance for every specimen.",
    gradient: "bg-gradient-to-b from-[#0098b0] to-[#0098b000]",
  },
  {
    title: "SOP-Driven Excellence",
    description:
      "Standardized pre-analytical handling ensures specimen integrity from collection to delivery.",
    gradient: "bg-gradient-to-b from-[#0098b0] to-[#0098b000]",
  },
  {
    title: " Maintained Cold Chain",
    description:
      "Temperature-controlled storage and shipping with continuous monitoring and documentation.",
    gradient: "bg-gradient-to-b from-[#0098b0] to-[#0098b000]",
  },
  {
    title: " Fast Turnaround Time",
    description:
      "Quick diagnostic results and efficient biospecimen procurement to keep your projects on schedule.",
    gradient: "bg-gradient-to-b from-[#0098b0] to-[#0098b000]",
  },
  {
    title: "Certified Quality",
    description:
      "Accredited labs, trained professionals, comprehensive quality documentation with every delivery.",
    gradient: "bg-gradient-to-b from-[#0098b0] to-[#0098b000]",
  },
];

export const features = [
  {
    title: "Ethical Sourcing",
    description:
      "IRB-approved protocols, informed consent, full regulatory compliance for every specimen.",
    gradient: "bg-gradient-to-b from-[#0098b0] to-[#0098b000]",
  },
  {
    title: "SOP-Driven Excellence",
    description:
      "Standardized pre-analytical handling ensures specimen integrity from collection to delivery.",
    gradient: "bg-gradient-to-b from-[#0098b0] to-[#0098b000]",
  },
  {
    title: " Maintained Cold Chain",
    description:
      "Temperature-controlled storage and shipping with continuous monitoring and documentation.",
    gradient: "bg-gradient-to-b from-[#0098b0] to-[#0098b000]",
  },
  {
    title: " Fast Turnaround Time",
    description:
      "Quick diagnostic results and efficient biospecimen procurement to keep your projects on schedule.",
    gradient: "bg-gradient-to-b from-[#0098b0] to-[#0098b000]",
  },
  {
    title: "Certified Quality",
    description:
      "Accredited labs, trained professionals, comprehensive quality documentation with every delivery.",
    gradient: "bg-gradient-to-b from-[#0098b0] to-[#0098b000]",
  },
];
